import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from '../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
const ErrorBlock = ({image, mainTitle, subTitle, buttonLink, buttonTitle, hideButton, isButtonPurple}) => {
  return (
    <div className='error-page-container'>
      {image ? (
        <Image className='error-page-custom-image' src={Config.epiBaseUrl + image} />
      ) : (
        <Image src={require('./Images/DefaultImage.svg')} />
      )}
      <h1 className='main-title'> {mainTitle}</h1>
      <h1 className='sub-title'> {subTitle}</h1>
      {!hideButton && (
        <span className={`error-page-button ${isButtonPurple && 'purple'}`} onClick={() => EpiContext.navigateTo(buttonLink)}>
          {buttonTitle}
        </span>
      )}
    </div>
  );
};

export default ErrorBlock;
